export default __webpack_public_path__ + "static/media/ojeras_1.ed501a33.jpg";